var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-pagination',_vm._g(_vm._b({attrs:{"next-icon":"keyboard_arrow_right","prev-icon":"keyboard_arrow_left","value":_vm.value}},'v-pagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }